module.exports = __webpack_public_path__ + "ca2917b1abaa2e3ae9ead4f5115db3f7.svg";